import React from 'react'
import { CCol, CFormInput, CFormLabel } from '@coreui/react-pro'
import PreviewImage from '../PreviewImage'

const BasicSetting = ({ gameName, onGameNameChange, logo, image, onImageChange }) => {
  return (
    <>
      <CCol md={12}>
        <CFormLabel className="fw-bold" htmlFor="game_name">
          Game Name*
        </CFormLabel>

        <CFormInput
          id="game_name"
          value={gameName || ''}
          name="game_name"
          onChange={(event) => onGameNameChange(event.target.value)}
        />
        <small>
          <i> ({`Ex: ABC Fantasy 2023-24`})</i>
        </small>
      </CCol>

      <CCol md={12}>
        <div>
          <CFormLabel className="fw-bold" htmlFor="formFile">
            Game Logo
          </CFormLabel>
          <CFormInput
            type="file"
            id="formFile"
            name="image"
            className="form-control input_user"
            onChange={(event) => onImageChange(event.target.files[0])}
          />
          <div
            className="d-flex align-items-center justify-content-center border rounded"
            style={{ width: 100, height: 100 }}
          >
            <img
              src={`${process.env.REACT_APP_API_URL}uploads/game_logo/${logo}`}
              alt="game logo"
              style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
            />
          </div>
          {image ? (
            <PreviewImage
              className={{ margin: 'auto' }}
              width="100px"
              height="100px"
              file={image}
            />
          ) : null}
        </div>
      </CCol>
    </>
  )
}

export default BasicSetting
